import React, { useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { normalizeAttachments } from './contentAttachments';
import './platform-content-pdf-embed.css';

function buildPdfViewerUrl(url) {
  if (!url) {
    return '';
  }
  const base = String(url).split('#')[0];
  return `${base}#page=1&zoom=100&navpanes=0`;
}

function ContentPdfEmbed({
  item,
  title = 'Izdanje',
  className = '',
}) {
  const attachments = useMemo(() => normalizeAttachments(item), [item]);
  const [activeIndex, setActiveIndex] = useState(0);

  if (!attachments.length) {
    return null;
  }

  const safeIndex = Math.min(activeIndex, attachments.length - 1);
  const activeAttachment = attachments[safeIndex];
  const viewerUrl = buildPdfViewerUrl(activeAttachment.url);

  return (
    <div className={`platform-content-pdf-embed ${className}`.trim()}>
      <div className="platform-content-detail-card">
        <div className="platform-content-detail-card__header platform-content-pdf-embed__header">
          <h2 className="platform-content-detail-card__title">{title}</h2>
          {attachments.length > 1 && (
            <div className="platform-content-pdf-embed__tabs" role="tablist" aria-label="PDF datoteke">
              {attachments.map((attachment, index) => (
                <Button
                  key={attachment.url}
                  size="sm"
                  variant={index === safeIndex ? 'primary' : 'outline-primary'}
                  onClick={() => setActiveIndex(index)}
                  role="tab"
                  aria-selected={index === safeIndex}
                >
                  {attachment.name}
                </Button>
              ))}
            </div>
          )}
        </div>
        <div className="platform-content-pdf-embed__frame-wrap">
          <iframe
            title={activeAttachment.name || 'PDF predogled'}
            src={viewerUrl}
            className="platform-content-pdf-embed__frame"
          />
        </div>
      </div>
    </div>
  );
}

export default ContentPdfEmbed;
